import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { Layout } from '../components/Layout';

export const Privacy: React.FC = () => {
  return (
    <Layout>
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="body1" color="text.secondary">
            Privacy policy content coming soon.
          </Typography>
        </Paper>
      </Box>
    </Layout>
  );
};
